module.exports = __webpack_public_path__ + "static/media/translate.f6b05a6d.svg";